import { version } from './version';

export const environment = {
  production: true,
  envName: 'devel',
  apiUrl: '',
  ipv4ApiUrl: '',
  wsUrl: 'is-test-client.vsh-labs.cz',
  cloudDnsWsUrl: 'client.is.lxd',
  googleSiteKey: '6LdUw48UAAAAALnxsH_vUxMNlAVWrCvd-OS-g2nC',
  cdnAuthRedirectUrl: 'http://localhost:4002/authorize',
  cloudMailAuthRedirectUrl: 'http://localhost:4003/authorize',
  gpuCloudAuthRedirectUrl: 'http://localhost:4005/authorize',
  release: version,
  enableCDNS: true,
  enableCDN: false,
  enableCloudMail: false,
  forceDevWsProtocol: 'wss',
  mojeIdConnectRedirectUrl: 'http://localhost:1337/external-auth/mojeid/connect',
  mojeIdLoginRedirectUrl: 'http://localhost:1337/external-auth/mojeid/login',
  googleConnectRedirectUrl: 'http://localhost:1337/external-auth/google/connect',
  googleLoginRedirectUrl: 'http://localhost:1337/external-auth/google/login',
  // There is a separate publishable Stripe key for each development environment,
  // so remember that fact when changing your development environment to another one.
  contractorIdCz: '2y0kXC6lTtiJlyRjPfNy7A',
  stripePublishableKeyCz: 'pk_test_51SAuhgEqC0B4VlVL7UE7lgi872Z4Ukdu8p1CKb0djEmo5w35a56LYf1e2cmi3LwYTuEyofo3MkNtTVHYWrl9Czhd00xS5DoF7T',
  contractorIdDe: '3XLi6Jad9kyIEAUQ43AaEA',
  stripePublishableKeyDe: 'pk_test_51SAuhgEqC0B4VlVL7UE7lgi872Z4Ukdu8p1CKb0djEmo5w35a56LYf1e2cmi3LwYTuEyofo3MkNtTVHYWrl9Czhd00xS5DoF7T',
  appleIdConnectRedirectUrl: 'http://is-test-client.vsh-labs.cz/external-auth/apple/connect',
  appleIdLoginRedirectUrl: 'http://is-test-client.vsh-labs.cz/external-auth/apple/login',
  // logoDevPublishableKey: 'pk_RYyUochIQVih1QmmRxnojQ'
  logoDevPublishableKey: 'pk_dohWEue0R5yYQ3kVdPV5uw'
};
